import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidMath } from '../../../../mechanics/rid-math/rid-math';

@Component({
  selector: 'app-math-page',
  imports: [RidMath],
  templateUrl: './math-page.html',
})
export class MathPage {
  protected readonly $router = inject(Router);
}
